export default __webpack_public_path__ + "static/media/classroom.b018dab5.jpg";